import { Component, Host, h } from '@stencil/core';

/**
 * @slot header - header显示内容,并用于展开折叠项目
 * @slot content - 基于expanded 显示隐藏的内容
 *
 * @part header - The wrapper element for the header slot.
 * @part content - The wrapper element for the content slot.
 * @part expanded - The expanded element. Can be used in combination
 * with the `header` and `content` parts (i.e. `::part(header expanded)`).
 */
@Component({
  tag: 'jackery-accordion',
  styleUrl: 'jackery-accordion.css',
  shadow: true,
})
export class JackeryAccordion {

  render() {
    return (
      <Host>
        <slot></slot>
      </Host>
    );
  }

}
